// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const uen: CountryValidator<"SG"> = createValidator(
  "sg.uen",
  157,
);

export default uen;
export const compact = uen.compact;
export const format = uen.format;
export const validate = uen.validate;
export const generate = (): string =>
  uen.generate?.() ??
  (() => {
    throw new Error(
      "Validator sg.uen cannot generate values",
    );
  })();
